<template>
  <div id="app"
    class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover appHomeList">
    <HeadNav selectedLanguage="en" page="gb" :gotodownload="gotodownload" :apk="apk" 
    :update="updateScrollTarget" @scroll-to-target="handleScollToTarget" />

    <div id="page" class="site container hfeed">
      <div id="content" class="site-content">
        <div id="primary" class="content-area">
          <div class="row-title">
            <div class="row-left">
              <div class="row-title-text">
                Lastest Version: v18.50
              </div>
              <h1>
                Download GB WhatsApp APK For Android 2025
              </h1>
              <div class="row-btns">
                <button class="btn-download" @click="goJump('https://gbwaapplus.com/gb-whatsapp-apk-download/')">Free
                  Download</button>
                <button class="btn-version" @click="goJump('https://gbwaapplus.com/gbwhatsapp-ban-issues/')">Anti-Ban
                  Version</button>
              </div>
              <div class="row-ghost">
                <div>√ Ghost Mode</div>
                <div> √ 4,000+ Themes</div>
                <div> √ Save Status</div>
                <div> √ Send Original Images</div>
              </div>
            </div>
            <div class="row-right">
              <div class="lazy-picture-container writer-banner width-75">
                <picture><img width="auto" height="auto" alt="gbwhatsapp image" src="../assets/gbwhatsappBg.webp">
                </picture>
              </div>
            </div>
          </div>
          <div class="safe-area">
            <div>
              <h2>
                App Introduction: What is GB WhatsApp?
              </h2>
              <div>
                <a href="https://gbwaapplus.com/" class="jump-url">GB WhatsApp</a> builds on the original WhatsApp with
                extra features and more control. It's free, safe, and
                packed with powerful tools for a better chat experience.
              </div>
            </div>
            <div>
              <svg t="1745736672845" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="44832" width="150" height="150">
                <path d="M813.9 831.9c-0.1 0-0.2 0.1-0.3 0.1 3.2-1.9 2.1-0.7 0.3-0.1z" fill="#2A5699" p-id="44833">
                </path>
                <path
                  d="M892.5 215.2c0-17.2-13.8-31.3-31.1-31.5l-34.5-0.6h-0.1c-2-0.1-73.7-2.1-146.8-31.8-77-31.3-127-67-128.6-68.1-0.1 0-0.1-0.1-0.2-0.1L530.3 68c-11.1-8-26-8-37.1 0.1l-20.7 15c-0.5 0.4-51.3 36.8-128.8 68.3-73.1 29.7-144.7 31.7-146.8 31.8l-34.7 0.6c-17.2 0.3-31.1 14.3-31.1 31.6v351.8c0 88 50.5 186.7 138.5 270.8 80.5 76.4 173.2 124 242.4 124 69.2 0 162-47.6 242.2-124.2 88-84.1 138.6-182.8 138.6-270.8l-0.3-351.8zM751.9 409.6L492.5 668.9c-9.3 9.3-22 14.6-35.2 14.6-13.2 0-25.9-5.2-35.2-14.6L292.4 539.3c-19.4-19.4-19.4-51 0-70.4 19.4-19.4 51-19.4 70.4 0l94.5 94.5 224.2-224.2c19.4-19.4 51-19.4 70.4 0 19.4 19.4 19.4 50.9 0 70.4z"
                  fill="#3FAE49" p-id="44834"></path>
              </svg>
            </div>
          </div>

          <Carousel />

          <div class="full-width-wrapper gradient-with-deco gradient">
            <h2 class="h">
              <span id="TBC_2"></span>Extra Features That Bypass WhatsApp Limitations
            </h2>
            <div>
              Modified WhatsApp versions like GB WhatsApp, WhatsApp Plus, and others unlock a wide range of features
              that users have long wished were available in the official app. Here are are extra features that bypass
              WhatsApp limitations.
            </div>
            <Features :features="features" />
          </div>
          <div class="android">
            <h2 style="padding: 20px 0;">Download GB WhatsApp on All Devices</h2>
            <div class="android-list">
              <div class="androin-left">
                <svg t="1745808933498" class="icon" viewBox="0 0 1024 1024" version="1.1"
                  xmlns="http://www.w3.org/2000/svg" p-id="2493" width="100" height="100">
                  <path
                    d="M615.878882 177.494507l42.303478-61.521169c1.811252-2.619664 1.146103-6.252401-1.473561-8.063653l-1.054005-0.726547c-2.619664-1.821485-6.231935-1.146103-8.043187 1.473561l-43.521213 63.291488c-28.427446-12.361539-60.139705-19.268856-93.601818-19.268856-31.753191 0-61.950957 6.221702-89.232301 17.426905l-41.587164-60.477396c-1.801019-2.619664-5.423523-3.284813-8.043187-1.473561l-1.054005 0.726547c-2.619664 1.811252-3.284813 5.443989-1.483794 8.073886l40.215934 58.461483c-63.23009 30.300097-108.664885 88.075964-117.915573 156.299789l438.20018 0C720.552873 265.017886 676.919097 208.296023 615.878882 177.494507zM418.217057 265.621637c-12.054547 0-21.837354-9.813506-21.837354-21.908986 0-12.095479 9.782807-21.898753 21.837354-21.898753 12.06478 0 21.837354 9.803273 21.837354 21.898753C440.054411 255.80813 430.281837 265.621637 418.217057 265.621637zM606.710059 265.621637c-12.054547 0-21.837354-9.813506-21.837354-21.908986 0-12.095479 9.782807-21.898753 21.837354-21.898753 12.06478 0 21.837354 9.803273 21.837354 21.898753C628.547413 255.80813 618.774839 265.621637 606.710059 265.621637z"
                    p-id="2494"></path>
                  <path
                    d="M260.904195 419.506423l0 179.446975c0 30.760584-19.596314 55.933917-43.562145 55.933917l-9.680477 0c-23.955598 0-43.562145-25.173332-43.562145-55.933917l0-179.446975c0-30.760584 19.606547-55.923684 43.562145-55.923684l9.680477 0C241.307881 363.582739 260.904195 388.745838 260.904195 419.506423z"
                    p-id="2495"></path>
                  <path
                    d="M859.896478 420.570661l0 179.446975c0 30.770817-19.596314 55.933917-43.562145 55.933917l-9.680477 0c-23.955598 0-43.562145-25.163099-43.562145-55.933917l0-179.446975c0-30.760584 19.606547-55.923684 43.562145-55.923684l9.680477 0C840.300164 364.646977 859.896478 389.810077 859.896478 420.570661z"
                    p-id="2496"></path>
                  <path
                    d="M732.934878 360.830045l0 354.074178c0 24.579815-20.046568 44.687782-44.554752 44.687782l-36.746926 0 0 102.320387c0 30.760584-19.606547 55.923684-43.562145 55.923684l-9.680477 0c-23.955598 0-43.562145-25.163099-43.562145-55.923684l0-102.320387-81.864496 0 0 101.143585c0 30.760584-19.596314 55.933917-43.562145 55.933917l-9.680477 0c-23.955598 0-43.562145-25.173332-43.562145-55.933917l0-101.143585-40.062438 0c-24.508183 0-44.554752-20.107967-44.554752-44.687782l0-354.074178L732.934878 360.830045z"
                    p-id="2497"></path>
                </svg>
                <div><strong>Android</strong></div>
                <div>
                  GB WhatsApp was originally developed for Android, because the system allows modified APKs
                  to bypass standard limitations. Click the button below to quickly download GB WhatsApp APK for any
                  Android device.
                </div>
                <button class="btn-download" @click="goJump('https://gbwaapplus.com/gb-whatsapp-apk-download/')">Free
                  Download</button>
              </div>
              <div class="androin-right">

                <div class="androin-right-item">
                  <svg t="1745812232093" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="3382" width="80" height="80">
                    <path
                      d="M959.9 310.4c2-43-4-86.1-17.7-127-22-52.2-66.2-91.8-120.4-108C786.4 66.6 750 62.7 713.5 64H310.4c-36.4-1.3-72.9 2.6-108.3 11.4-54.2 16.2-98.4 55.8-120.4 108-13.6 40.9-19.7 83.9-17.7 127v403.1c-1.9 43.1 4.1 86.1 17.7 127 22 52.2 66.2 91.8 120.4 108 35.4 8.8 71.8 12.7 108.3 11.4h403.1c36.4 1.3 72.9-2.6 108.3-11.4 54.2-16.2 98.4-55.8 120.4-108 13.6-40.9 19.7-83.9 17.7-127V310.4zM241.7 680h-33.3V481h33.3v199zM225 447.4c-11.4-0.1-20.6-9.4-20.5-20.9 0.1-11.4 9.4-20.6 20.9-20.5 11.3 0.1 20.5 9.3 20.5 20.7-0.1 11.5-9.4 20.8-20.9 20.7zM425.1 685c-87.9 0-143.3-62.8-143.3-162.7s55.3-162.9 143.3-162.9 143.5 63 143.5 162.9S513.3 685 425.1 685z m290.2 0c-66 0-112.4-36.4-115.7-90.8h30c3.3 37.9 38.9 63.6 88.4 63.6 47.3 0 81.2-25.8 81.2-61.2 0-29.5-20.4-47-67.2-58.8l-39.2-10.1c-58.4-14.9-84.4-39.6-84.4-81.2 0-51 45.9-87.3 108-87.3 61.6 0 106.4 36.4 108.3 86.4h-30c-2.8-35.6-34.4-59.3-79.2-59.3-43.7 0-76.1 24.3-76.1 59 0 27.1 19.6 43.1 66 54.9l34.2 8.8c63.4 16 90.1 40.3 90.1 84.2 0.1 55.5-44.6 91.8-114.4 91.8zM425.1 387.1c-69.1 0-112.6 52.3-112.6 135.2S356 657.2 425.1 657.2 538 604.9 538 522.3s-43.7-135.2-112.9-135.2z"
                      p-id="3383"></path>
                  </svg>
                  <div>
                    <strong>iOS:</strong> Actually, there is no official GBWhatsApp iOS version. In short, you can't use
                    GB WhatsApp on
                    iPhones. <br>
                    <span class="learn-more" @click="goJump('https://gbwaapplus.com/gb-whatsapp-ios/')">Learn
                      More>></span>
                  </div>
                </div>
                <div class="androin-right-item">
                  <svg t="1745808951110" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="3542" width="80" height="80">
                    <path
                      d="M899.544477 127.981836 123.664507 127.981836c-32.962739 0-59.683311 28.626991-59.683311 63.943334l0 447.601294c0 35.31532 26.720571 63.943334 59.683311 63.943334l358.098841 0-119.366621 191.82898 298.41553 0-119.366621-191.82898 358.098841 0c32.962739 0 59.683311-28.626991 59.683311-63.943334L959.227788 191.925171C959.227788 156.608827 932.508239 127.981836 899.544477 127.981836zM899.544477 575.583131c0 35.31532-26.720571 63.943334-59.683311 63.943334L183.347818 639.526465c-32.962739 0-59.683311-28.626991-59.683311-63.943334L123.664507 255.867482c0-35.31532 26.720571-63.943334 59.683311-63.943334L839.862189 191.924147c32.962739 0 59.683311 28.626991 59.683311 63.943334L899.5455 575.583131z"
                      p-id="3543"></path>
                  </svg>
                  <div>
                    <strong>Windows:</strong> To use GB WhatsApp on a PC (similar to WhatsApp Web), you can try an
                    Andorid emulator. <br>
                    <span class="learn-more" @click="goJump('https://gbwaapplus.com/gb-whatsapp-for-pc/')">Learn
                      More>></span>
                  </div>
                </div>
                <div class="androin-right-item">
                  <svg t="1745812259125" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="4445" width="80" height="80">
                    <path
                      d="M960 108.8c35.2 0 64 28.8 64 64v518.4c0 35.2-28.8 64-64 64H646.4l57.6 115.2c6.4 16 0 35.2-12.8 41.6-3.2 3.2-9.6 3.2-12.8 3.2H348.8c-19.2 0-32-12.8-32-32 0-6.4 0-9.6 3.2-12.8l57.6-115.2H64c-35.2 0-64-28.8-64-64V172.8c0-35.2 28.8-64 64-64h896zM598.4 294.4c-35.2-3.2-67.2 19.2-86.4 19.2-16 0-41.6-19.2-70.4-19.2-35.2 0-70.4 22.4-89.6 54.4-38.4 64-9.6 163.2 25.6 217.6l6.4 9.6c16 22.4 35.2 48 60.8 44.8 28.8 0 38.4-19.2 70.4-19.2 32 0 41.6 19.2 70.4 16 28.8 0 48-25.6 67.2-54.4s28.8-60.8 28.8-60.8h-3.2C665.6 496 624 473.6 624 416c0-54.4 44.8-80 48-83.2-19.2-32-57.6-38.4-73.6-38.4z m0-105.6c-22.4 0-48 16-64 32-12.8 16-25.6 41.6-22.4 67.2 25.6 0 48-12.8 64-32 12.8-16 25.6-41.6 22.4-67.2z"
                      fill="#888888" p-id="4446"></path>
                  </svg>
                  <div>
                    <strong>macOS:</strong> Like iOS, macOS does not support APK files. We recommend using the official
                    WhatsApp Web or
                    desktop app instead. <br>
                    <!-- <span class="learn-more">Learn More>></span> -->
                  </div>
                </div>
              </div>
              <div>

              </div>
            </div>
          </div>
          <div class="requirement-section">
            <h2>Requirements to Download GB WhatsApp APK For Andorid</h2>
            <div class="connection">
              <ol class="custom-counter-ol">
                <li> Stable internet connection</li>
                <li> Android OS version 5.0 or higher (compatible with all major phone brands)</li>
                <li> An active WhatsApp account</li>
                <li> No need to root your device</li>
                <li> Enable "Unknown Sources" installation in your device settings (to allow GB WhatsApp APK file
                  installation)</li>
                <li> Enough storage space (at least 200 MB recommended)</li>
                <li> Diable Goolg Play Protect if it blocks GB WhatsApp App Installation</li>
              </ol>
            </div>
          </div>
          <div class="requirement-section">
            <h2>GB WhatsApp App Info & Screenshot</h2>
            <div class="screenshot-section">
              <div class="screenshot-left">
                <div class="screenshot-row">
                  <table class="has-fixed-layout">
                    <tbody>
                      <tr>
                        <th>App Name</th>
                        <th>GBWhatsApp</th>
                      </tr>
                      <tr>
                        <td>Size</td>
                        <td>
                          80MB
                        </td>
                      </tr>
                      <tr>
                        <td>Version</td>
                        <td>18.50</td>
                      </tr>
                      <tr>
                        <td>Developer</td>
                        <td>
                          Alexmods
                        </td>
                      </tr>
                      <tr>
                        <td>Support OS</td>
                        <td>Android 5.0+</td>
                      </tr>
                      <tr>
                        <td>Last Updated</td>
                        <td>March, 2025</td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- <button class="btn-download" @click="goJump('https://gbwaapplus.com/gb-whatsapp-apk-download/')">Download GBWhatsApp</button> -->
                </div>
              </div>
              <div class="screenshot-right">
                <el-carousel :height="screenshotHeight" indicator-position="none">
                  <el-carousel-item v-for="item in carouselList" :key="item">
                    <img :src="item.img" alt="" class="carousel-img" />
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>
          <div class="requirement-section">
            <h2>GBWhatsApp APK Installation & Update Guide</h2>
            <div>
              Recently, Google Play has strengthened its security measures, especially in scanning third-party APKs. If
              you try to install GB WhatsApp apk on your phone, you might encounter the Play protect block.
            </div>
            <div>
              <strong>Solution:</strong> <br>
              To bypass this, simply disable Google Play Protect temporarily in your Play Store settings during
              installation. Once installed, you can re-enable Play Protect for future security.
            </div>
          </div>
          <div class="requirement-section">
            <h2>Steps to Download & Install GB WhatsApp</h2>
            <div>
              <el-steps direction="vertical" :active="4" class="custom-steps">
                <el-step title="Enable Unknown Source"
                  description='Go to Settings > Security (or Privacy) and click on "Unknown Sources" or "Install unknown apps". Then, your phone will allow the installaiton of apps from sources other than the Play Store. Once installed, you can disable it again. '></el-step>
                <el-step title="Download GB WhatsApp APK"
                  description="You can download the GBWhatsApp APK for Android on our site. It's safe, free and contains no hidden fees or intrusive ads."></el-step>
                <el-step title="Install GB WhatsApp "
                  description="Follow the on-screen guide to install GBWhatsApp. Make sure to grant all necessary permissions. This is a standard process to ensure the app functions properly."></el-step>
                <el-step title="Verify Account"
                  description="GB WhatsApp is connected to the WhatsApp system. You can login via WhatsApp account directly. Then enjoy all the exciting features!"></el-step>
              </el-steps>
            </div>
          </div>
          <div :ref="updateScrollTarget" class="requirement-section">
            <h2>How to Update GB WhatsApp to the Latest Version</h2>
            <div class="update-section">
              <div class="update-last">
                <h3>What's New of GBWhatsApp v18.50?</h3>
                <ol class="custom-counter-ol">
                  <li>
                    Last Updated: April 8
                  </li>
                  <li>
                    Fixed: Crashes
                  </li>
                  <li>
                    Anti-Ban Enhancement
                  </li>
                  <li>
                    ❗ This Update Can't Work With Banned Numbers ❗
                  </li>
                </ol>
              </div>
              <div class="update-last1">
                <h3>Methods to Update GBWhatsApp Old Version</h3>
                <div>
                  Once a new version is released, our website updates the GBWhatsApp APK packages immediately. Users can
                  download the latest version directly from our trusted website. <br>
                  You can also check the <strong>in-app update notice</strong>, which may notify you when an update is
                  available.
                  However, since GBWhatsApp is not available on the official app stores,<strong> you may need to
                    download the
                    APK file manually.</strong>
                </div>
                <div style="margin-top: 10px;">
                  <button class="btn-download"
                    @click="goJump('https://gbwaapplus.com/gb-whatsapp-apk-download/')">Download GBWhatsApp Latest
                    Version</button>
                </div>
              </div>

            </div>
            <div class="requirement-WhatsApp">
              <h2>Why Choose GB WhatsApp?</h2>
            </div>
            <div style="width: 100%; margin: 0 auto 30px;">
              <el-tabs tab-position="left" type="border-card" class="custom-tabs">
                <el-tab-pane>
                  <span slot="label"><i class="el-icon-house"></i> Pros</span>
                  <div>
                    <ul>
                      <li> Access to advanced privacy controls (hide status, blue ticks, etc.)</li>
                      <li> Full media sharing in original quality</li>
                      <li> Ability to run multiple WhatsApp accounts on one device</li>
                      <li> Built-in themes, fonts, and emoji customization</li>
                    </ul>
                  </div>
                </el-tab-pane>
                <el-tab-pane>
                  <span slot="label"><i class="el-icon-date"></i> Cons</span>
                  <div>
                    <ul>
                      <li> Not available on Google Play Store or Apple App Store</li>
                      <li> Risk of temporary or permanent ban from the official WhatsApp</li>
                      <li> Requires manual updates</li>
                    </ul>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="colored-bg">
              <h2 class="h">
                <span id="TBC_1">Comparison: GB WhatsApp vs Official WhatsApp</span>
              </h2>
              <figure class="wp-block-table is-style-regular">
                <table class="has-fixed-layout">
                  <tbody>
                    <tr>
                      <th>Feature</th>
                      <th>GB WhatsApp</th>
                      <th>Official WhatsApp</th>
                    </tr>
                    <tr>
                      <td>Send Original Images</td>
                      <td>√</td>
                      <td>×</td>
                    </tr>
                    <tr>
                      <td>Ghost Mode</td>
                      <td>√</td>
                      <td>×</td>
                    </tr>
                    <tr>
                      <td>DND Mode</td>
                      <td>√</td>
                      <td>×</td>
                    </tr>
                    <tr>
                      <td>Change Themes</td>
                      <td>√</td>
                      <td>×</td>
                    </tr>
                    <tr>
                      <td>Stickers Effect</td>
                      <td>√</td>
                      <td>×</td>
                    </tr>
                    <tr>
                      <td>Change App Icon</td>
                      <td>√</td>
                      <td>×</td>
                    </tr>
                    <tr>
                      <td>App Lock</td>
                      <td>√</td>
                      <td>×</td>
                    </tr>
                    <tr>
                      <td>Hide the Second Tick</td>
                      <td>√</td>
                      <td>×</td>
                    </tr>
                    <tr>
                      <td>Disable Read Receipt</td>
                      <td>√</td>
                      <td>√</td>
                    </tr>
                    <tr>
                      <td>Unread Messages</td>
                      <td>√</td>
                      <td>√</td>
                    </tr>
                    <tr>
                      <td>Share Live Location</td>
                      <td>√</td>
                      <td>√</td>
                    </tr>
                    <tr>
                      <td>Media Sharing Limit</td>
                      <td>Larger files (up to 1GB)</td>
                      <td>Standard file size limit (16MB for media)</td>
                    </tr>
                    <tr>
                      <td>Update Frequency</td>
                      <td>Less frequent, based on developer's schedule</td>
                      <td>Regular, official updates from WhatsApp Inc.</td>
                    </tr>
                    <tr>
                      <td>Official Support</td>
                      <td>No official support, third-party app</td>
                      <td>Full official support from WhatsApp</td>
                    </tr>
                    <tr>
                      <td>Security</td>
                      <td>Vulnerable to bans, not officially supported</td>
                      <td>End-to-end encryption, official security</td>
                    </tr>
                    <tr>
                      <td>Backup/Restore</td>
                      <td>Can transfer chats via backup</td>
                      <td>Official WhatsApp backups via Google Drive</td>
                    </tr>
                    <tr>
                      <td>Multi-Device Use</td>
                      <td>Can use multiple devices with mods</td>
                      <td>Limited to one phone per account</td>
                    </tr>
                  </tbody>
                </table>
              </figure>
            </div>
            <div class="requirement-section" style="margin-bottom: 0;padding-bottom: 0;">
              <h2>How to Transfer WhatsApp Chat to GB WhatsApp</h2>
              <div>
                Transferring your WhatsApp chat history to GB WhatsApp is a straightforward process. Here’s how you can
                do it: <br>
                <ol>
                  <li> <strong>Backup your chats on Official WhatsApp:</strong>
                    Open WhatsApp and go to Settings > Chats > Chat Backup. Tap Back Up to create a backup of your chats
                    to Google Drive or locally on your device. </li>
                  <li> <strong>Install GB WhatsApp:</strong>
                    Download the latest version of GB WhatsApp from a trusted source. Make sure to allow installations
                    from unknown sources in your device's settings if necessary.</li>
                  <li> <strong>Restore your backup on GB WhatsApp:</strong>
                    After installing GB WhatsApp, open the app and verify your phone number. It will prompt you to
                    restore your chat history. Choose the backup you created earlier (either from Google Drive or local
                    storage) to restore your chats.</li>
                  <li> <strong> Complete the setup:</strong>
                    Once the restore is complete, your chats will be transferred to GB WhatsApp, and you can start using
                    the app with all your previous conversations intact.</li>
                </ol>
                By following these steps, you can easily transfer your chat history from WhatsApp to GB WhatsApp without
                losing any important messages.
              </div>
            </div>
            <div class="requirement-section">
              <h2>Top WhatsApp Mods – GB WhatsApp Alternatives</h2>
              <div class="tabs-pane-connection">
                <el-tabs>
                  <el-tab-pane label="FM WhatsApp">
                    <div>
                      <div class="logo-connection">
                        <img src="../assets/fm-logo.webp" class="fm-logo" alt="">
                        <div>FM WhatsApp, developed by Fouad Mokdad, is a popular mod that offers smoother performance
                          and
                          more stable updates. It allows deep interface customization and better theme management than
                          GBWhatsApp. It's ideal for users who want a visually polished experience.</div>
                      </div>
                      <div>
                        <strong>FM WhatsApp VS GBWhatsApp:</strong> <br>
                        FM WhatsApp provides a more stable user experience and focuses heavily on design
                        personalization, while GBWhatsApp prioritizes privacy and extra messaging tools.
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="WhatsApp Plus">
                    <div>
                      <div class="logo-connection">
                        <img src="../assets/plus-logo.webp" class="fm-logo" alt="">
                        <div>WhatsApp Plus is one of the earliest mods known for its wide range of color themes and
                          interface styles. It focuses more on visual appearance than privacy tweaks. If you're into
                          changing fonts, layouts, and colors frequently, this is a great option.</div>
                      </div>
                      <div>
                        <strong>WhatsApp Plus VS GBWhatsApp:</strong> <br>
                        WhatsApp Plus emphasizes UI design and visual customizations, whereas GBWhatsApp focuses more on
                        privacy options and hidden features like hiding recording/typing status.
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="YO WhatsApp">
                    <div>
                      <div class="logo-connection">
                        <img src="../assets/yo-logo.webp" class="fm-logo" alt="">
                        <div>YO WhatsApp (YoWA) gives an iOS-style interface on Android devices and maintains strong
                          privacy options. It's cleaner and simpler than GBWhatsApp in design. Perfect for users who
                          want
                          a modern, iPhone-like WhatsApp experience.</div>
                      </div>
                      <div>
                        <strong>YO WhatsApp VS GBWhatsApp:</strong> <br>
                        YO WhatsApp delivers a more iOS-like feel and cleaner design, perfect for users who want the
                        iPhone WhatsApp interface on Android.
                      </div>
                    </div>
                  </el-tab-pane>
                  <el-tab-pane label="OG WhatsApp">
                    <div>
                      <div class="logo-connection">
                        <img src="../assets/og-logo.webp" class="fm-logo" alt="">
                        <div>OG WhatsApp is a lightweight and reliable mod for dual WhatsApp accounts on the same phone.
                          It focuses on core privacy and media-sharing enhancements without extra complexity. Great for
                          users who prefer stability and simplicity over too many features.</div>
                      </div>
                      <div>
                        <strong>OG WhatsApp VS GBWhatsApp:</strong> <br>
                        OG WhatsApp is lighter and more basic, great for users who want extra privacy and dual-account
                        use without overwhelming features.
                      </div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
            <div class="requirement-WhatsApp">
              <h2>2025 Trends: What Users Want in WhatsApp Mods </h2>
            </div>
            <div class="connection protection">
              <ul>
                <li> Anti-ban protection</li>
                <li> Lightweight with advanced features</li>
                <li> Telegram-inspired upgrades</li>
                <li> In-chat translator, voice changer</li>
                <li> Status downloader & message scheduler</li>
              </ul>
            </div>
            <div class="requirement-section">
              <h2>Troubleshooting: Common Issues of GB WhatsApp</h2>
              <div class="connection faq-list">
                <h3 class="gberro">GB WhatsApp Installation Errors:</h3>
                <p>
                  If you're having trouble installing the APK file, here are some quick fixes:
                </p>
                <ul>
                  <li>
                    <strong>Enable "Unknown Sources" </strong> <br>
                    On your Android device, go to Settings > Security > Install unknown apps, and allow your browser or
                    file manager to install apps from unknown sources.
                  </li>
                  <li>
                    <strong>Google Play Protect Warning</strong> <br>
                    Some users may encounter a warning from Google Play Protect. To continue, you can temporarily
                    disable Play Protect by going to Play Store > Play Protect > Settings > Turn off "Scan apps with
                    Play Protect".
                  </li>
                  <li>
                    <strong>Corrupted APK File</strong> <br>
                    If the installation still fails, try downloading the APK file again from our official site to avoid
                    corrupted or incomplete files.
                  </li>
                  <li>
                    <strong> Insufficient Storage</strong> <br>
                    Make sure your device has enough storage space for the new version. Try clearing some space before
                    attempting installation.
                  </li>
                </ul>
              </div>
              <div class="connection faq-list">
                <h3 class="gberro">Ban Risk & How to Use GB WhatsApp Without Being Banned</h3>
                <div>
                  Because GB WhatsApp is a third-party app, there is a small chance that users may experience a
                  temporary or permanent ban from the official WhatsApp system. To reduce the risk:
                </div>
                <ol>
                  <li> Always use the Anti-Ban version of GB WhatsApp, which is regularly updated with new protection.
                  </li>
                  <li> Avoid spamming, broadcasting to large groups frequently, or forwarding mass messages, especially
                    to unknown users.</li>
                  <li> Do not use outdated versions of GB WhatsApp. Always update to the latest version from a reliable
                    source.</li>
                  <li> Enable all privacy settings responsibly and avoid triggering suspicious behavior (like hiding
                    online status while being very active).</li>
                </ol>
              </div>
              <div class="connection faq-list">
                <h3 class="gberro">Crashing or Freezing</h3>
                <div>
                  If your GB WhatsApp app crashes or freezes often, try these solutions:
                </div>
                <ul>
                  <li> <strong> Clear cache</strong>: Go to Settings > Apps > GB WhatsApp > Storage > Clear Cache to
                    remove temporary files that might be causing lag.</li>
                  <li> <strong>Update to the latest version</strong>: Older versions may have bugs or compatibility
                    issues with newer Android systems.</li>
                  <li> <strong>Restart your phone</strong>: A simple reboot can often fix minor glitches.</li>
                  <li> <strong>Free up RAM</strong>: Too many background apps can slow down performance, especially on
                    low-end devices.</li>
                  <li><strong> Reinstall GB WhatsApp</strong>: If issues persist, back up your chats and reinstall the
                    app from a trusted source.</li>
                </ul>
              </div>
            </div>
            <div class="section-content">
              <h2 class="h">
                <span id="TBC_6">
                  FAQ
                </span>
              </h2>
              <div class="faq-list">
                <FAQ :faqs="faqs" />
              </div>
            </div>
            <Carousel2></Carousel2>
          </div>
         
        </div>
      </div>
    </div>

    <div v-if="$global.isMobileDevice()" id="fixed-bottom-btn" class="fix-bottom-btn" @click="gotodownload()">
      Download GBWhatsApp New
    </div>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
import Features from '@/components/Features.vue';
import FAQ from '@/components/FAQ.vue';
import Carousel from '@/components/Carousel.vue';
import Carousel2 from '@/components/Carousel2.vue';

export default {
  name: 'Home',
  components: {
    HeadNav,
    Features,
    FAQ,
    Carousel,
    Carousel2
  },
  data() {
    return {
      updateScrollTarget:'scrollTarget',//head中update菜单的滚动目标位置
      pageName: 'home',
      tableHide: true,
      comment: {
        name: '',
        email: '',
        content: '',
      },
      showapk: false,
      screenshotHeight: '400px',
      selectedFeature: null,
      apk: null,
      from: 'gb',
      filename: 'gb',
      clickNum: 0,
      selectedLanguage: 'en',
      carouselList: [
        {
          img: require('@/assets/carousel1.webp'),
        },
        {
          img: require('@/assets/carousel2.webp'),
        },
        {
          img: require('@/assets/carousel3.webp'),
        },
        {
          img: require('@/assets/carousel4.webp'),
        },
      ],
      lang: [{
        lang: 'en',
        val: '🇺🇸 English'
      },
      {
        lang: 'ar',
        val: '🇦🇪 اَلْعَرَبِيَّةُ'
      },
      {
        lang: 'id',
        val: '🇮🇩 Bahasa Indonesia'
      },
      {
        lang: 'pt',
        val: '🇵🇹 Português'
      },
      {
        lang: 'es',
        val: '🇪🇸 Español'
      },
      {
        lang: 'hi',
        val: '🇮🇳 हिंदी'
      },
      ],
      features: [{
        title: "Remove Media/File Size Caps",
        text: "Send large videos, documents, and files far beyond the official app's size limits."
      },
      {
        title: "Broadcast to Unlimited Contacts",
        text: "Reach out to a larger audience at once with unlimited broadcast capabilities."
      },
      {
        title: "Send Longer Video Statuses",
        text: "Upload videos over the standard 30-second limit for more expressive status updates."
      },
      {
        title: "Forward Messages with No Tag",
        text: "Share messages without the “forwarded” label, keeping the chat more natural and discreet."
      },
      {
        title: "Change WhatsApp Icon",
        text: "Customize the app icon to match your home screen style or hide its presence."
      },
      {
        title: "Ghost Mode",
        text: "Stay online and view others’ activities while remaining invisible to them — the ultimate stealth feature."
      },

      ],
      androidSrc: require('@/assets/android.svg'),
      androidSrc2: require('@/assets/android.svg'),
      faqs: [{
        question: "Is it safe to use GB WhatsApp?",
        answer: "GBWhatsApp is safe if downloaded from a trusted source. However, it's a third-party app not verified by WhatsApp Inc., which means there is a small risk of account bans."
      },
      {
        question: "Is GBWhatsApp Legal?",
        answer: "GBWhatsApp is not officially legal or illegal. It operates in a grey area because it's a modified version of the original WhatsApp. While it's widely used, it does violate WhatsApp's Terms of Service."
      },
      {
        question: "How to change home screen of GB WhatsApp?",
        answer: "To change the home screen layout, go to: GB Settings > Home Screen > Header > Customize. From there, you can personalize layout styles, icons, and appearance."
      },
      {
        question: "Can GBWhatsApp block video call?",
        answer: `Yes, GBWhatsApp allows you to control who can call you. Go to: GB Settings > Privacy > Who Can Call Me, and select from options like "Everyone," "My Contacts," or "Nobody."`
      },
      {
        question: "Can I use WhatsApp and GB WhatsApp on the same phone?",
        answer: `Yes, you can use both apps on the same device as long as you register them with different phone numbers. This is useful for managing personal and professional accounts separately.`
      },
      {
        question: "Should I always download GBWhatsApp latest version?",
        answer: `Yes, always update to the latest version to enjoy new features, improved performance, bug fixes, and stronger anti-ban protection.`
      },
      {
        question: "Is GB WhatsApp available for iPhone?",
        answer: `No, GBWhatsApp is primarily made for Android. It is not officially available for iPhone, and installing it on iOS devices requires jailbreaking.`
      },
      {
        question: "Who is the developer of GB WhatsApp?",
        answer: `GBWhatsApp was originally developed by Atnfas Hoak. Later, different versions and updates have been released by other developers like HeyMods and others in the modding community.`
      },
      {
        question: "What should I do if my account be banned?",
        answer: `If you receive a temporary ban, stop using GBWhatsApp and wait for the ban period to expire. Then, update to the latest anti-ban version. To reduce the risk of future bans, don’t spam or misuse features, and always use the most recent version.`
      }
      ],

    };
  },
  computed: {
    downloadURL() {
      // var params = window.location.search;
      // return `/gbwhatsapp-apk-download${params}`;
      if (typeof window === 'undefined') {
        // Server-side rendering logic
        return '/gbwhatsapp-apk-download'; // Adjust this based on your server-side logic
      } else {
        // Client-side rendering logic
        let params = window.location.search;
        return `/gbwhatsapp-apk-download${params}`;
      }
    },
  },
  // created() {
  //   // 设置默认选中第一个特性

  // },
  mounted() {
    if (window.innerWidth > 768) {
      this.screenshotHeight = '400px';
    } else {
      this.screenshotHeight = '200px';
    }
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }

    // window.adsTag.renderInterstitial(54982);
  },
  methods: {
     handleScollToTarget(){
      this.$refs[this.updateScrollTarget].scrollIntoView({
      behavior: 'smooth'
      });
    },
    changeImage(newImage) {
      this.androidSrc = require(`@/assets/${newImage}`);
    },
    changeImage2(newImage) {
      this.androidSrc2 = require(`@/assets/${newImage}`);
    },
    changeLanguage(lang) {
      console.log(lang);
      // 处理语言选择变化
      // 这里可以添加其他处理逻辑，例如将语言保存到cookie或localStorage中
      this.$router.push({
        name: `${this.selectedLanguage}-gb`
      });
    },
    downloadClick() {
      this.$router.push({
        name: 'en-download'
      });
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    goJump(url) {
      window.location.href = url;
    },
    gotodownload() {
      console.log(this.apk);
      // this.showapk = true
      if (this.apk) {
        this.$global.download(this.apk);
      }

    },
    gotoblog() {
      window.location.href = '/blogs';
    },
    jump(url) {
      window.location.href = url;
    },
  },
};
</script>
<style lang="scss" scoped>
$--group-option-flex: 0 calc(1 / 5) * 100% !default;

.row-title {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-items: center;
  align-items: center;
  gap: 20px;
  max-width: 1200px;
  margin: auto;
  padding: 40px 0;

  .row-title-text {
    margin-bottom: 20px;
    font-size: 20px;
    font-weight: 600;
  }

  .row-btns {
    display: flex;
    gap: 20px;
    margin: 25px 0;
  }



  .btn-version {
    padding: 10px 20px;
    font-size: 20px;
    border-radius: 12px;
    background: #fff;
    color: #025cd8;
    border: 1px solid #025cd8;
    cursor: pointer;
    transition: all 0.3s ease-in-out;

    &:hover {
      background: #0077cc;
      color: #fff;
    }
  }

  .row-ghost {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
}

h2 {
  font-weight: 700;
  font-size: 34px;
}

.btn-download {
  padding: 10px 20px;
  font-size: 20px;
  border: none;
  border-radius: 12px;
  background: #025cd8;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  border: 1px solid #025cd8;

  &:hover {
    background: #fff;
    color: #025cd8;
    border: 1px solid #025cd8;
  }

}

.safe-area {
  display: flex;
  max-width: 1200px;
  margin: auto;
  align-items: center;
  padding: 20px;
  border-radius: 20px;
  background: rgb(240 252 251);
}

.android {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;

  .androin-left {
    width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    box-shadow: 0 0 10px #ccc;
    border-radius: 12px;
    cursor: pointer;
    justify-content: space-around;

    &:hover {
      box-shadow: 0 0 20px #000;
      transform: translateY(-4px);
    }
  }
}

.android-list {
  display: flex;
  gap: 30px;
}

.androin-right {
  display: flex;
  gap: 20px;
  flex-direction: column;
}

.androin-right-item {
  display: flex;
  width: 500px;
  padding: 20px;
  box-shadow: 0 0 10px #ccc;
  border-radius: 12px;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  &:hover {
    box-shadow: 0 0 20px #000;
    transform: translateY(-4px);
  }
}

.learn-more {
  text-align: right;
  display: block;
  font-size: 14px;
  text-decoration: underline;
}

.requirement-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px;
  max-width: 1200px;
  margin: 30px auto;
}

.tabs-pane-connection {}

.requirement-WhatsApp {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 30px;
  max-width: 1200px;
}

.custom-tabs {
  height: 160px;
}

.update-section {
  display: flex;
  gap: 30px;
}

.logo-connection {
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
}

.update-last {
  flex: 1;
  padding: 20px;
  background: linear-gradient(to right, #abefed, #69b6e5);
  border-radius: 12px;
}

.update-last1 {
  flex: 2;
  padding: 20px;
  background: linear-gradient(to right, #abefed, #69b6e5);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.screenshot-section {
  display: flex;
  gap: 30px;
  align-items: center;
}

.carousel-img {
  width: 100%;
  height: 100%;
}

.screenshot-row {
  display: flex;
  flex-direction: column;
}

.screenshot-right {
  width: 660px;
  flex: 2;
}

.connection {
  padding: 0 20px;
  background: #f0fcfb;
  border-radius: 12px;
  box-shadow: 0 0 10px #ccc;
}

.protection {
  width: 100%;
  padding-top: 20px;
}

.faq-list {
  margin-bottom: 20px;
}

.gberro {
  margin-top: 20px;
}

.custom-counter-ol {
  list-style-type: none;
  /* 移除默认编号 */
  padding-left: 50px;
  /* 留出空间给自定义编号 */
  counter-reset: list-counter;
  /* 初始化计数器 */
}

.custom-counter-ol li {
  position: relative;
  /* 为伪元素定位 */
  margin-bottom: 16px;
  /* 列表项间距 */
  counter-increment: list-counter;
  /* 计数器递增 */
}

.custom-counter-ol li::before {
  content: counter(list-counter) ".";
  /* 显示计数器值，加点号 */
  position: absolute;
  left: -30px;
  /* 编号位置 */
  color: #ff4500;
  /* 编号颜色 */
  font-size: 16px;
  /* 编号大小 */
  font-weight: bold;
  /* 编号加粗 */
  background-color: #f0f0f0;
  /* 编号背景 */
  border-radius: 50%;
  /* 圆形背景 */
  width: 28px;
  /* 背景宽度 */
  height: 28px;
  /* 背景高度 */
  display: flex;
  align-items: center;
  justify-content: center;
}

.fm-logo {
  width: 80px;
  height: 80px;
}

::v-deep .el-tabs--left.el-tabs--border-card .el-tabs__item.is-left.is-active {
  width: 120px;
  background: #d5f1ff;
}

/* 修改所有文字颜色为 #000 */
.custom-steps ::v-deep .el-step__title,
.custom-steps ::v-deep .el-step__description {
  color: #000 !important;
}

/* 调整步骤间垂直间距为 20px */
// .custom-steps ::v-deep .el-step.is-vertical {
//   margin-bottom: 20px !important;
// }

/* 调整步骤内部文字间距 */
.custom-steps ::v-deep .el-step__description {
  margin-bottom: 20px !important;
  /* 标题与描述间距 */
  line-height: 1.5 !important;
  /* 可选：增加行高提升可读性 */
}

@media (max-width: 768px) {
  .appHomeList {
    overflow: hidden;
  }

  .row-title {
    grid-template-columns: repeat(1, 1fr);
    padding: 20px;
  }

  .safe-area {
    flex-direction: column;
    margin: 0 20px;
  }

  .android-list {
    flex-direction: column;
    align-items: center;

    .androin-left {
      width: 90vw;
    }

    .androin-right-item {
      width: 90vw;
    }
  }

  .screenshot-section {
    flex-direction: column;
  }

  .screenshot-right {
    width: 90vw;
  }

  .update-section {
    flex-direction: column;
  }

  .custom-tabs {
    height: auto;
  }

  .tabs-pane-connection {
    width: 80vw;
  }
}
</style>
